import 'core-js'
import React from 'react'
import { render } from 'react-dom'
import Main from './main'

// Retrieve the nonce from the meta tag
const nonce = document.querySelector('meta[nonce]')?.getAttribute('nonce');

render(<Main nonce={nonce} />, document.getElementById('root'))
